import { Action, Reducer } from 'redux';
import {
  ContactTypeState,
  ContactTypeTypes,
  ContactTypeActionTypes
} from './contactTypeTypes';

export const INITIAL_STATE: ContactTypeState = {
  contactType: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const contactTypeReducer: Reducer<ContactTypeState> = (
  state: ContactTypeState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as ContactTypeActionTypes;
  switch (actionTypes.type) {
    case ContactTypeTypes.GET_CONTACT_TYPE:
      return {
        ...state,
        contactType: { ...state.contactType, isLoading: true }
      };
    case ContactTypeTypes.SAVE_CONTACT_TYPE:
      return {
        ...state,
        contactType: {
          ...state.contactType,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case ContactTypeTypes.RESET_REDUCER_CONTACT_TYPE:
      return {
        ...state,
        contactType: INITIAL_STATE.contactType
      };
    default:
      return state;
  }
};

export default contactTypeReducer;
